import React from 'react';
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import { Input } from 'reactstrap';

import americanExpressImg from '../../../assets/img/cards/american-express.png';
import dinersClubImg from '../../../assets/img/cards/diners-club.png';
import discoverImg from '../../../assets/img/cards/discover.png';
import jcbImg from '../../../assets/img/cards/jcb.png';
import mastercardImg from '../../../assets/img/cards/mastercard.png';
import unionPayImg from '../../../assets/img/cards/union-pay.png';
import visaImg from '../../../assets/img/cards/visa.png';
import countryCodes from '../../../assets/js/countryCodes';
import history from '../../../utils/history';
import CircularLoading from '../../Common/CircularLoading/CircularLoading';
import { CancelSubscriptionScheduleModal } from '../../ManageSubscription/UpdateSubscriptionPlan/CancelSusbcriptionScheduleModal';
import ElementCard from '../../SignUp/SubscriptionBillingModal/ElementCard';

const MONTH_PARSER = {
  '01': 'January',
  '02': 'February',
  '03': 'March',
  '04': 'April',
  '05': 'May',
  '06': 'June',
  '07': 'July',
  '08': 'August',
  '09': 'September',
  10: 'October',
  11: 'November',
  12: 'December',
};

const style = {
  empty: {
    '::placeholder': {
      color: '#adb5bd',
      fontWeight: '400',
      fontFamily: 'sans-serif',
    },
  },
  base: {
    fontSize: '16px',
    fontWeight: '400',
    color: '#1c3b60',
    fontFamily: 'sans-serif',
  },
};

// This is displayed in Account Settings view in the right side
class ManageSubscription extends React.Component {
  constructor(props) {
    super(props);
    // reference to the Stripe element
    this.cardElement = null;
    this.state = {
      isEditingPaymentDetails: false,
      firstName: '',
      lastName: '',
      address: '',
      city: '',
      country: { name: 'United States', shortCode: 'US' },
      state: { name: '', shortCode: '' },
      cardElementMounted: false,
      expirationElementMounted: false,
      cvcElementMounted: false,
      zip: '',
      plansLoaded: false,
      tokenCard: '',
      isLoadingTokenCard: false,
      errorMessage: '',
      openCancelUpdate: false,
    };
  }

  // save reference when the item is ready
  handleCardReady = (element) => {
    this.cardElement = element;
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.plans.length && !this.state.plansLoaded) {
      this.setState({ plansLoaded: true });
    }
    if (nextProps.editPaymentDetailsSuccess) {
      this.resetComponent();
    }

    // if (nextProps.editPaymentDetailsMessage.text !== '') {
    //   this.props.setEditPaymentDetailsMessage({ type: 'success', text: '' });
    // }

    if (nextProps.editPaymentDetailsMessage?.type === 'error') {
      // Clean using Stripe API
      if (this.cardElement) {
        this.cardElement.clear();
      }
      this.setState({
        tokenCard: '',
        zip: '',
      });
    }
  }

  UNSAFE_componentWillMount() {
    this.props.loadPlans();
  }

  resetComponent = () => {
    this.setState({
      isEditingPaymentDetails: false,
      firstName: '',
      lastName: '',
      address: '',
      city: '',
      country: { name: 'United States', shortCode: 'US' },
      state: { name: '', shortCode: '' },
      cardElementMounted: false,
      expirationElementMounted: false,
      cvcElementMounted: false,
      cardCVC: '',
      cardExpiry: '',
      cardNumber: '',
      zip: '',
    });
  };

  // REGION DATA MANAGE

  getCountryShortCode = (countryName) => {
    const normalizedCountryName = countryName
      .normalize('NFD')
      .replace(/\p{Diacritic}/gu, '');
    const country = countryCodes.find((c) => c.name === normalizedCountryName);
    return country?.code;
  };

  handleCountryOptionClick = (countryName) => {
    this.setState({
      country: {
        name: countryName,
        shortCode: this.getCountryShortCode(countryName),
      },
      state: { name: '', shortCode: '' },
    });
  };

  handleStateOptionClick = (stateName) => {
    this.setState({
      state: {
        name: stateName,
        shortCode: '',
      },
    });
  };

  handleEditPaymentDetailsStatus = (value) => {
    this.setState({ isEditingPaymentDetails: value });
    if (!value) {
      this.setState({
        cardElementMounted: false,
        expirationElementMounted: false,
        cvcElementMounted: false,
      });
    }
  };

  handleFirstNameChange = (e) => {
    this.setState({ firstName: e.target.value });
  };

  handleLastNameChange = (e) => {
    this.setState({ lastName: e.target.value });
  };

  handleAddressChange = (e) => {
    this.setState({ address: e.target.value });
  };

  handleCityChange = (e) => {
    this.setState({ city: e.target.value });
  };

  handleZipChange = (e) => {
    this.setState({ zip: e.target.value });
  };

  componentWillUnmount() {
    // set message to initial state
    if (this.props.editPaymentDetailsMessage.text !== '')
      this.props.setEditPaymentDetailsMessage({ type: 'success', text: '' });
  }

  componentDidUpdate() {
    const cardNumberDiv = document.getElementById('card-number');
    const expirationDateDiv = document.getElementById('card-expiration');
    const cardCVCDiv = document.getElementById('card-cvc');
    const _this = this;

    // CARD NUMBER
    if (cardNumberDiv && !this.state.cardElementMounted) {
      const cardNumberElement = elements.create('cardNumber', {
        style,
        placeholder: 'Card Number',
      });
      cardNumberElement.mount('#card-number');
      this.cardNumber = cardNumberElement;
      this.setState({ cardElementMounted: true });
      _this.cardNumber.addEventListener('change', (event) => {
        if (event.error) {
          _this.setState({ cardNumber: '' });
        }
        if (event.complete) {
          _this.setState({ cardNumber: _this.cardNumber });
        }
      });
    }

    // CARD EXPIRATION
    if (expirationDateDiv && !this.state.expirationElementMounted) {
      const cardExpiryElement = elements.create('cardExpiry', { style });
      cardExpiryElement.mount('#card-expiration');
      this.cardExpiry = cardExpiryElement;
      this.setState({ expirationElementMounted: true });
      _this.cardExpiry.addEventListener('change', (event) => {
        if (event.error) {
          _this.setState({ cardExpiry: '' });
        }
        if (event.complete) {
          _this.setState({ cardExpiry: _this.cardExpiry });
        }
      });
    }

    // CARD CVC
    if (cardCVCDiv && !this.state.cvcElementMounted) {
      const cardCVCElement = elements.create('cardCvc', { style });
      cardCVCElement.mount('#card-cvc');
      this.cardCVC = cardCVCElement;
      this.setState({ cvcElementMounted: true });
      _this.cardCVC.addEventListener('change', (event) => {
        if (event.error) {
          _this.setState({ cardCVC: '' });
        }
        if (event.complete) {
          _this.setState({ cardCVC: _this.cardCVC });
        }
      });
    }
  }

  dataCard = (value) => {
    if (value) {
      // clear previous request error message
      this.props.setEditPaymentDetailsMessage({ type: 'success', text: '' });
      this.setState({
        tokenCard: value.tokenCard,
        zip: value.zip,
      });
    }
  };

  errorMessage = (value) => {
    this.setState({ errorMessage: value });
  };

  renderEditPaymentDetailsOptions = () => {
    const disabledButton =
      this.state.address === '' ||
      this.state.city === '' ||
      this.state.firstName === '' ||
      this.state.lastName === '' ||
      this.state.country.name === '' ||
      this.state.country.shortCode === '' ||
      this.state.state.name === '' ||
      this.state.tokenCard === '' ||
      this.state.errorMessage !== '' ||
      this.props.editPaymentDetailsWaiting ||
      this.state.isLoadingTokenCard;

    const cardData = {
      address_line1: this.state.address,
      address_city: this.state.city,
      address_state: this.state.state.name,
      address_country: this.state.country.shortCode,
      address_zip: this.state.zip,
      name: `${this.state.firstName.trim()} ${this.state.lastName.trim()}`.trim(),
    };

    return (
      <div className="edit-payment-details-container fade-in">
        <div className="big-title fade-in">Edit Payment Details</div>
        <div className="payment-card-container ">
          <div className="title fade-in">Payment Card</div>
          {/* FIRST NAME */}
          <div className="input-container full-width">
            <div className="label fade-in">first name</div>
            <Input
              id="first-name"
              className="edit-payment-input fade-in"
              value={this.state.firstName}
              type="text"
              onChange={this.handleFirstNameChange}
            />
          </div>
          {/* LAST NAME */}
          <div className="input-container full-width">
            <div className="label fade-in">last name</div>
            <Input
              id="last-name"
              className="edit-payment-input fade-in"
              value={this.state.lastName}
              type="text"
              onChange={this.handleLastNameChange}
            />
          </div>
        </div>
        <div className="billing-address-container">
          <div className="title fade-in">Billing Address</div>
          {/* ADDRESS */}
          <div className="input-container full-width" data-test="address-input">
            <div className="label fade-in">address</div>
            <Input
              id="adress"
              className="edit-payment-input fade-in"
              value={this.state.address}
              type="text"
              onChange={this.handleAddressChange}
            />
          </div>
          {/* CITY */}
          <div className="input-container full-width">
            <div className="label fade-in">city</div>
            <Input
              id="city"
              className="edit-payment-input fade-in"
              value={this.state.city}
              type="text"
              onChange={this.handleCityChange}
            />
          </div>

          {/* COUNTRY */}
          <div className="input-container full-width">
            <div className="field">
              <div className="manage-subscription-selector">
                <div className="label fade-in">country</div>
                <CountryDropdown
                  blacklist={['CU', 'UA', 'IR', 'KP', 'SY']}
                  value={this.state.country.name}
                  onChange={(country) => this.handleCountryOptionClick(country)}
                  classes="manage-subscription-dropdown-toggle fade-in"
                />
              </div>
            </div>
          </div>

          {/* STATE */}
          <div className="input-container full-width">
            <div className="field">
              <div className="manage-subscription-selector">
                <div className="label fade-in">state</div>
                <RegionDropdown
                  country={this.state.country.name}
                  value={this.state.state.name}
                  onChange={(state) => this.handleStateOptionClick(state)}
                  classes=" manage-subscription-dropdown-toggle fade-in"
                  defaultOptionLabel="Select State"
                  data-test="state-dropdown"
                />
              </div>
            </div>
          </div>

          {/* CARD NUMBER */}
          <ElementCard
            dataCard={this.dataCard}
            cardData={cardData}
            errorMessage={this.errorMessage}
            onCardReady={this.handleCardReady}
            setLoadingStripeToken={(value) => {
              this.setState({ isLoadingTokenCard: value });
            }}
          />
          {this.state.errorMessage && (
            <div className="subscription-message message-error">
              {this.state.errorMessage}
            </div>
          )}
        </div>
        <button
          className="btn btn-danger btn-block"
          onClick={() => this.editPaymentDetails(cardData)}
          disabled={disabledButton}
          data-test="edit-payment-save-button"
        >
          {this.renderButtonText()}
        </button>
        {this.props.editPaymentDetailsMessage.text !== '' &&
          this.props.editPaymentDetailsMessage.type === 'error' && (
            <div className="subscription-message message-error">
              {this.props.editPaymentDetailsMessage.text}
            </div>
          )}
      </div>
    );
  };

  renderButtonText = () => {
    const isEditPaymentDetailsWaiting = this.props.editPaymentDetailsWaiting;
    const isLoadingTokenCard = this.state.isLoadingTokenCard;

    if (isEditPaymentDetailsWaiting) {
      return <CircularLoading className="loading-gif-waiting button-gif" />;
    }
    if (isLoadingTokenCard) {
      return (
        <>
          <span>Validating Card</span>
          <CircularLoading
            className="loading-gif-btn button-gif"
            height="24px"
            width="24px"
          />
        </>
      );
    }
    return 'Submit';
  };

  getSubscriptionDetailsText = () => {
    const { userSubscription, user } = this.props;

    if (userSubscription?.guestAccountScheduledStart) {
      const startDate = new Date(
        Number(userSubscription?.guestAccountScheduledStart),
      ).toLocaleDateString('en-US');
      if (user.transactionIosId) {
        return (
          <div className="subscription-details">
            You have been granted a free period. It will begin on{' '}
            <strong>{startDate}</strong>, once your current subscription period
            ends. Please remember to cancel your Apple subscription manually
            from your device before that date.
          </div>
        );
      }
      return (
        <div className="subscription-details">
          You have been granted a free period. It will begin on{' '}
          <strong>{startDate}</strong>, once your current Stripe subscription is
          canceled at the end of the billing period.
        </div>
      );
    }

    const noSubscriptionMessage = (
      <div className="subscription-details">
        You do not currently have a subscription. Upgrade your account to access
        all features!
      </div>
    );
    if (!user.active) {
      return noSubscriptionMessage;
    }
    // note: ios subscriptions has userSubscription.id = null
    if (!userSubscription || !userSubscription.id) {
      if (user.transactionIosId) {
        return (
          <div className="subscription-details">
            You have an iOS subscription. Because of Apple's security rules, you
            cannot manage it from the website and must cancel it from your Apple
            device.
          </div>
        );
      }
      return noSubscriptionMessage;
    }

    const subscriptionNextRenewal =
      this.getSubscriptionNextRenewal(userSubscription);
    const cardDetailsText = this.getCardDetailsText(userSubscription);
    if (user.isGuestAccount && user.guestAccountExpiration) {
      return (
        <div className="subscription-details">You have a free account.</div>
      );
    }

    if (userSubscription.scheduledPlan && userSubscription.card) {
      return (
        <div className="subscription-details">
          Your account has a plan update scheduled. Your account services will
          be updated on <strong>{subscriptionNextRenewal}</strong> and your{' '}
          {cardDetailsText}
        </div>
      );
    }

    if (userSubscription.isCancelled && userSubscription.cancelledReason) {
      return (
        <div className="subscription-details">
          Your account has been canceled. Your account services will stop on{' '}
          <strong>{userSubscription.next_bill_date}</strong>, at the end of this
          billing term. You'll have access to your subscription services and
          features until then.
        </div>
      );
    }

    if (!userSubscription.card) {
      return (
        <div className="subscription-details">
          You don't have any payment details on your account and your
          subscription is set to expire on {userSubscription.next_bill_date}.
          You can add your card details in the button below to maintain your
          subscription.
        </div>
      );
    }
    if (userSubscription.status === 'active') {
      return (
        <div className="subscription-details">
          Your subscription will renew on{' '}
          <strong>{subscriptionNextRenewal}</strong> and {cardDetailsText || ''}
        </div>
      );
    }

    if (userSubscription.status === 'trialing') {
      return (
        <div className="subscription-details">
          Your subscription is currently on its trial period. {cardDetailsText}{' '}
          on <strong>{subscriptionNextRenewal}</strong>
        </div>
      );
    }

    if (userSubscription.status === 'past_due') {
      return (
        <div className="subscription-details">
          Your last payment attempt failed and your subscription is set to
          expire on {userSubscription.next_bill_date}. You can modify your card
          details in the button below or retry your payment by clicking the
          retry payment button{' '}
          <span
            className="here-button"
            onClick={() => history.push('/app/manage-subscription')}
          >
            here
          </span>
          .
        </div>
      );
    }
  };

  getSubscriptionNextRenewal = (userSubscription) => {
    if (userSubscription && userSubscription.next_bill_date) {
      const month =
        MONTH_PARSER[String(userSubscription.next_bill_date.slice(0, 2))];
      const day = userSubscription.next_bill_date.slice(3, 5);
      const year = userSubscription.next_bill_date.slice(6, 10);
      return `${month} ${day}, ${year} `;
    }
    return '';
  };

  getCardDetailsText = (userSubscription) => {
    if (userSubscription && userSubscription.card && this.state.plansLoaded) {
      const { plans, coupon } = this.props;
      let discount = 0;
      const amount =
        userSubscription.scheduledPlan &&
        plans.find((p) => p.id === userSubscription.scheduledPlan)
          ? (
              plans.find((p) => p.id === userSubscription.scheduledPlan)
                .amount / 100
            ).toFixed(2)
          : userSubscription.amount;
      if (coupon) {
        if (coupon.amountOff) discount = (amount - coupon.amountOff).toFixed(2);

        if (coupon.percentageOff)
          discount = (amount - amount * (coupon.percentageOff / 100)).toFixed(
            2,
          );
      }

      return (
        <span>
          {`${userSubscription.card.brand} ending in `}
          <strong>{userSubscription.card.last4}</strong>
          {' will be charged '}
          <span>
            {coupon && (coupon.amountOff || coupon.percentageOff) ? (
              <span>
                <strong>
                  <del>{`$${amount}`}</del>
                  <i>{` $${discount}`}</i>
                </strong>
                {`. You have a ${
                  coupon.amountOff
                    ? `$${coupon.amountOff}`
                    : `${coupon.percentageOff}%`
                } discount coupon applied`}
              </span>
            ) : (
              <strong>{`$${amount}`}</strong>
            )}
          </span>
        </span>
      );
    }
    return '';
  };

  getCardDetails = () => {
    const userSubscription = this.props.userSubscription;
    if (
      userSubscription &&
      userSubscription.card &&
      userSubscription.card.brand
    ) {
      return (
        <div className="card-details-container">
          <div className="card-logo">
            {this.getPaymentMethodImage(userSubscription.card)}
          </div>
          <div className="card-data">
            <div className="last-four">
              {this.getBrandAndLastFour(userSubscription.card)}
            </div>
            <div className="expiration-date">
              {this.getCardExpirationDate(userSubscription.card)}
            </div>
          </div>
        </div>
      );
    }
    if (this.props.user && this.props.user.isFreeAccount) {
      return (
        <div className="no-details-container">
          No card data available. Upgrade your account to have full access to
          all study material and features
        </div>
      );
    }
    return <div className="no-details-container">No card data available</div>;
  };

  getPaymentMethodImage = (card) => {
    let image = null;
    switch (card.brand) {
      case 'Visa':
        image = visaImg;
        break;
      case 'American Express':
        image = americanExpressImg;
        break;
      case 'Diners Club':
        image = dinersClubImg;
        break;
      case 'Discover':
        image = discoverImg;
        break;
      case 'JCB':
        image = jcbImg;
        break;
      case 'MasterCard':
        image = mastercardImg;
        break;
      case 'UnionPay':
        image = unionPayImg;
        break;
      default:
        image = null;
        break;
    }

    if (card && card.brand && image) {
      return (
        <img height="45" width="78" className="cardImage" src={image} alt="" />
      );
    }
  };

  getBrandAndLastFour = (card) => {
    if (card) {
      return `${card.brand} ****${card.last4}`;
    }
    return '';
  };

  getCardExpirationDate = (card) => {
    if (card) {
      return `Expires: ${card.exp_month}/${card.exp_year}`;
    }
    return '';
  };

  getSubscriptionStatus = () => {
    const { userSubscription, user } = this.props;

    if (
      userSubscription &&
      user.transactionIosId &&
      userSubscription.status === 'active'
    ) {
      return (
        <div className="status">
          <span className="status-circle active" />
          <span className="status-name">Active</span>
        </div>
      );
    }

    if (this.props.user && this.props.user.isFreeAccount) {
      return (
        <div className="status">
          <span className="status-circle no-active" />
          <span className="status-name">Free Account</span>
        </div>
      );
    }
    if (
      userSubscription &&
      userSubscription.id &&
      !this.props.user.transactionIosId
    ) {
      if (
        userSubscription.status === 'active' ||
        userSubscription.status === 'trialing' ||
        userSubscription.scheduledPlan
      ) {
        return (
          <div className="status">
            <span className="status-circle active" />
            <span className="status-name">{userSubscription.status}</span>
          </div>
        );
      }
      return (
        <div className="status">
          <span className="status-circle no-active" />
          <span className="status-name">
            {userSubscription.status
              ? userSubscription.status
              : userSubscription.isCancelled
                ? 'Cancelled'
                : 'Inactive'}
          </span>
        </div>
      );
    }

    return (
      <div className="status">
        <span className="status-circle no-active" />
        <span className="status-name">Inactive</span>
      </div>
    );
  };

  getIncompleteSubscriptionText = () => {
    const userSubscription = this.props.userSubscription;
    if (userSubscription && userSubscription.status === 'incomplete') {
      return (
        <div className="legacy-text">
          Your subscription is <strong className="red">incomplete</strong>. If
          you used a coupon, it has already been consumed. Please complete your
          subscription by sending the remaining check from your bank, or contact
          support to request a replacement coupon <strong>before</strong> making
          a new attempt to pay for the account.
        </div>
      );
    }
  };

  getLegacySubscritpionText = () => {
    const userSubscription = this.props.userSubscription;
    if (userSubscription && userSubscription.isValidPlan === false) {
      return (
        <div className="legacy-text">
          You are currently on a legacy plan that will be{' '}
          <b className="red"> discontinued</b> at the end of its term.{' '}
          <b>You are being automatically transferred to the new plan.</b> If you
          wish to cancel your plan and not be billed again, please do so before
          your scheduled payment date. If you wish to switch from the annual
          plan to a monthly or semi-annual plan, please contact us at
          support@promotionwingman.com and we will help make that change.
        </div>
      );
    }
  };

  getSubscriptionTitle = (userSubscription, currentSubscription) => {
    switch (userSubscription.interval) {
      // case 'Monthly':
      //   return 'Monthly Subscription';
      case 'SemiAnnually':
      case 'month':
        return userSubscription?.isOccupational
          ? 'Semi-Annual Subscription (PFE+SKT)'
          : 'Semi-Annual Subscription (PFE Only)';
      case 'Annually':
      case 'year':
        return userSubscription?.isOccupational
          ? 'Annual Subscription (PFE+SKT)'
          : 'Annual Subscription (PFE Only)';

      // if (currentSubscription) {
      //   return userSubscription?.warfarePlan === true
      //     ? 'Warfare & Qualifications Only Subscription'
      //     : 'Annual Subscription';
      // }
      // // scheduledSubscription
      // return userSubscription &&
      //   userSubscription?.product?.name === 'Warfare & Qualifications Only'
      //   ? 'Warfare & Qualifications Only Subscription'
      //   : 'Annual Subscription';

      // case 'month':
      //   if (userSubscription.interval_count === 1)
      //     return 'Monthly Subscription';
      //   return 'Semi-Annual Subscription';
      default:
        return '';
    }
  };

  getAccessText = (userSubscription, currentSubscription) => {
    if (currentSubscription) {
      return userSubscription?.isOccupational
        ? 'Full access to all PFE and SKT study material and features. Cancel anytime.'
        : 'Full access to all PFE study material and features. Cancel anytime.';
      // if (userSubscription.warfarePlan === true)
      //   return 'Access to study material and functions of quals and certs';
      // if (userSubscription.interval === 'Monthly')
      //   return 'Access to study material and functions of quals and certs.\nAudio functionality not included.';
      // return 'Full access to all study material and features.';
    }
    // scheduledSubscription

    return userSubscription &&
      userSubscription.product &&
      userSubscription.product.name === 'Warfare & Qualifications Only'
      ? 'Access to study material and functions of quals and certs'
      : 'Full access to all study material and features.';
  };

  getCurrentSubscriptionDetails = () => {
    const userSubscription = this.props.userSubscription;
    const isFree = this.props.user.isGuestAccount;
    if (
      userSubscription &&
      userSubscription.id &&
      (userSubscription.amount || isFree) &&
      userSubscription.status
    ) {
      return (
        <div className="current-subscription-details">
          <div className="contents">
            <div
              className="subscription-name"
              data-test="current-subscription-name"
            >
              {this.getSubscriptionTitle(userSubscription, true)}
            </div>
            <div className="subscription-amount">
              {isFree ? 'Free' : `$${userSubscription.amount}`}
            </div>
            <div className="subscription-description">
              {this.getAccessText(userSubscription, true)}
            </div>
          </div>
        </div>
      );
    }
  };

  getScheduledSubscriptionDetails = () => {
    if (this.props.userSubscription?.guestAccountScheduledStart) {
      const { guestAccountType } = this.props.userSubscription;
      const interval = {
        'pfe-skt-semi': 'SemiAnnually',
        'pfe-skt-annual': 'Annually',
        'pfe-only-semi': 'SemiAnnually',
        'pfe-only-annual': 'Annually',
      }[guestAccountType];
      const isOccupational = guestAccountType?.includes('skt');

      return (
        <div className="current-subscription-details">
          <div className="contents">
            <div
              className="subscription-name"
              data-test="current-subscription-name"
            >
              {this.getSubscriptionTitle({ interval, isOccupational }, false)}{' '}
            </div>
            <div className="subscription-amount">Free</div>
            <div className="subscription-description">
              Full access to all study material and features.
            </div>
          </div>
        </div>
      );
    }

    if (
      this.props.userSubscription &&
      this.props.user.transactionIosId &&
      this.props.userSubscription.status === 'active' &&
      !this.props.userSubscription.scheduleCreateSubscription
    ) {
      return (
        <div className="current-subscription-details">
          <div className="contents">
            <div
              className="subscription-name"
              data-test="current-subscription-name"
            >
              iOS{' '}
              {this.props.userSubscription.interval
                ? this.props.userSubscription.interval.replace(
                    'Auto-Renewable ',
                    '',
                  )
                : 'Subscription'}
            </div>
            <div className="subscription-amount">{`$${(
              this.props.userSubscription.amount / 1000
            ).toFixed(2)}`}</div>
          </div>
        </div>
      );
    }

    if (!this.state.plansLoaded) return;

    let scheduledSubscription = this.props.plans.find(
      (p) => p.id === this.props.userSubscription.scheduledPlan,
    );
    if (this.props.userSubscription.scheduleCreateSubscription) {
      scheduledSubscription =
        this.props.userSubscription.scheduleCreateSubscription;
    }
    if (scheduledSubscription && scheduledSubscription.amount) {
      return (
        <div className="current-subscription-details">
          <div className="contents">
            <div
              className="subscription-name"
              data-test="current-subscription-name"
            >
              {this.getSubscriptionTitle(scheduledSubscription, false)}
            </div>
            <div className="subscription-amount">{`$${(scheduledSubscription.amount / 100).toFixed(2)}`}</div>

            <div className="plan-item-description">
              {`${
                scheduledSubscription.interval === 'month'
                  ? scheduledSubscription.interval_count === 6
                    ? 'per 6 months'
                    : 'per month'
                  : 'per year'
              } (plus tax)`}
            </div>
            <div className="subscription-description">
              {this.getAccessText(scheduledSubscription, false)}
            </div>
            {this.props.userSubscription.scheduleCreateSubscription &&
              scheduledSubscription.discount && (
                <div className="subscription-description mt-2">
                  {' '}
                  A coupon has been applied to your account. On your next
                  invoice, you will only need to pay{' '}
                  <span style={{ fontWeight: 'bold' }}>
                    {scheduledSubscription.discount.totalPrice} + tax
                  </span>
                </div>
              )}
          </div>
        </div>
      );
    }
  };

  editPaymentDetails = async (cardData) => {
    this.props.editPaymentDetails(this.props.userSubscription.id, {
      isEditPaymentDetails: true,
      stripeToken: this.state.tokenCard,
      cardData,
    });
  };

  handleCancelSchedule = () => {
    this.props.cancelScheduleIosStripeSwitch();
    this.setState({ openCancelUpdate: false });
  };

  render() {
    const { userSubscription, user } = this.props;
    return (
      <div className="manage-subscription-container">
        <div className="manage-subscription-header">
          <div className="title">Manage My Subscription</div>
          {!this.props.laodingUserSubscription &&
            this.getSubscriptionDetailsText()}
          {this.props.laodingUserSubscription && (
            <div className="subscription-details loading-centered">
              <CircularLoading className="loading-gif-waiting" />
            </div>
          )}
        </div>

        {user &&
        user.active &&
        !user.transactionIosId &&
        !user.isGuestAccount ? (
          <div className="manage-subscription-payment-method">
            <div className="payment-method-content">
              <div className="title">Payment Method</div>
              {!this.props.laodingUserSubscription && this.getCardDetails()}
              {/* above refactored: !this.props.laodingUserSubscription && <CardDetails userSubscription={this.props.userSubscription} user={this.props.user}/> */}
              {this.props.laodingUserSubscription && (
                <div className="subscription-details loading-centered">
                  <CircularLoading className="loading-gif-waiting" />
                </div>
              )}
              {!this.state.isEditingPaymentDetails &&
                !this.props.laodingUserSubscription &&
                this.props.user &&
                !this.props.user.isFreeAccount && (
                  <button
                    className="edit-payment-details-button btn btn-outline-secondary btn-block rounded-lg"
                    disabled={
                      this.props.userSubscription &&
                      this.props.userSubscription.type !== 'stripe'
                    }
                    onClick={() => this.handleEditPaymentDetailsStatus(true)}
                    data-test="edit-payment-details-button"
                  >
                    edit payment details
                  </button>
                )}
              {this.props.editPaymentDetailsMessage.text !== '' &&
                this.props.editPaymentDetailsMessage.type === 'success' && (
                  <div className="subscription-message message-success">
                    {this.props.editPaymentDetailsMessage.text}
                  </div>
                )}
              {this.state.isEditingPaymentDetails &&
                this.renderEditPaymentDetailsOptions()}
            </div>
          </div>
        ) : null}
        <div className="manage-subscription-current-subcription">
          <div className="current-subcription-header">
            <div className="title">Current subscription</div>
            {!this.props.laodingUserSubscription &&
              this.getSubscriptionStatus()}
          </div>
          {!user.transactionIosId &&
          userSubscription &&
          !userSubscription?.scheduledPlan &&
          !userSubscription?.guestAccountScheduledStart &&
          userSubscription?.status === 'active' ? (
            <div className="current-subcription-header">
              <div className="title">
                {userSubscription?.isCancelled ||
                (userSubscription.type === 'stripe' &&
                  !userSubscription.card) ||
                user.isGuestAccount
                  ? 'Account services stop on'
                  : 'Account services renew on'}
              </div>
              <div className="date">
                {' '}
                {user.isGuestAccount
                  ? new Date(
                      Number(user.guestAccountExpiration),
                    ).toLocaleDateString('en-US')
                  : userSubscription?.next_bill_date}
              </div>
            </div>
          ) : (
            ''
          )}

          {this.getLegacySubscritpionText()}
          {this.getIncompleteSubscriptionText()}
          {(user.transactionIosId &&
            userSubscription &&
            userSubscription.status === 'active') ||
          (userSubscription && userSubscription.scheduledPlan) ||
          userSubscription?.guestAccountScheduledStart ? (
            <div className="scheduled-subscription-container">
              <div className="scheduled-subcription-header">
                Scheduled Subscription:{' '}
              </div>
              {!this.props.laodingUserSubscription &&
                this.getScheduledSubscriptionDetails()}
              <div className="scheduled-subcription-footer">
                <div className="title">
                  {userSubscription?.guestAccountScheduledStart
                    ? 'Free period starts on'
                    : 'Subscription plan changes on'}
                </div>
                <div className="date-update">
                  {userSubscription?.guestAccountScheduledStart
                    ? new Date(
                        Number(userSubscription?.guestAccountScheduledStart),
                      ).toLocaleDateString('en-US')
                    : userSubscription?.scheduleCreateSubscription
                      ? `${userSubscription.scheduleCreateSubscription.start_date}`
                      : !user.transactionIosId
                        ? userSubscription?.next_bill_date
                        : new Date(userSubscription.endedDate)
                            .toLocaleString()
                            .split(',')[0]}
                </div>
              </div>
              <div className="cancel-schedule-ios">
                {userSubscription.scheduleCreateSubscription &&
                  userSubscription.type === 'iOS' && (
                    <button
                      className="bottom-button btn btn-outline-danger btn-block rounded-lg"
                      onClick={() =>
                        this.setState({
                          openCancelUpdate: true,
                        })
                      }
                    >
                      Cancel scheduled plan update
                    </button>
                  )}
              </div>
            </div>
          ) : (
            !this.props.laodingUserSubscription &&
            this.getCurrentSubscriptionDetails()
          )}
          {this.props.laodingUserSubscription && (
            <div className="subscription-details loading-centered">
              <CircularLoading className="loading-gif-waiting" />
            </div>
          )}
        </div>
        {!user.transactionIosId && (
          <div className="manage-subscription-bottom-buttons">
            {!user.isGuestAccount &&
              !userSubscription?.guestAccountScheduledStart && (
                <div
                  className="bottom-button btn btn-outline-secondary btn-block rounded-lg"
                  data-test="manage-my-subscription-button"
                  onClick={() => history.push('/app/manage-subscription')}
                >
                  manage my subscription
                </div>
              )}
          </div>
        )}
        {user.transactionIosId &&
          !userSubscription?.scheduleCreateSubscription && (
            <div className="manage-subscription-bottom-buttons">
              {!userSubscription?.guestAccountScheduledStart && (
                <div
                  className="bottom-button btn btn-outline-secondary btn-block rounded-lg"
                  data-test="manage-my-subscription-button"
                  onClick={() => history.push('/app/manage-subscription')}
                >
                  continue my subscription on the web
                </div>
              )}
            </div>
          )}
        {this.state.openCancelUpdate && (
          <CancelSubscriptionScheduleModal
            open={this.state.openCancelUpdate}
            onClose={() => {
              this.setState({
                openCancelUpdate: false,
              });
            }}
            callback={() => this.handleCancelSchedule()}
          />
        )}
      </div>
    );
  }
}

export default ManageSubscription;
